class FaqItem {
  faq: HTMLElement;
  question: HTMLElement | null;
  answer: HTMLElement | null;
  activeClass: string;
  inactiveClass: string;

  constructor(
    faqItem: HTMLElement,
    headerClass: string,
    contentClass: string,
    activeClass: string,
    inactiveClass: string,
  ) {
    this.faq = faqItem;
    this.question = faqItem.querySelector(headerClass);
    this.answer = faqItem.querySelector(contentClass);
    this.activeClass = activeClass;
    this.inactiveClass = inactiveClass;
  }

  init() {
    if (this.faq && this.answer && this.question) {
      this.faq.classList.remove(this.activeClass);

      this.question.addEventListener("click", () => {
        this.toggleCollapse();
      });
    }
  }

  public toggleCollapse(): void {
    this.faq.classList.toggle(this.activeClass);
  }
}

export default FaqItem;
